import { ReactNode } from 'react';

interface FieldsetLabelProps {
  label: ReactNode;
}

export const FieldsetLabel = ({ label }: FieldsetLabelProps) => {
  return <div className="caption-medium-regular flex gap-tiny-small pb-tiny-medium text-neutral-foreground-low">{label}</div>;
};
